import React from "react";

const STANDARD_OPTIONS = [
  { value: "", label: "Everyone" },
  { value: "male", label: "Males Only" },
  { value: "female", label: "Females Only" },
];

const NON_BINARY_OPTIONS = [
  { value: "Men", label: "Men" },
  { value: "Women", label: "Women" },
  { value: "Non-binary", label: "Non-binary" },
  { value: "Transgender", label: "Transgender" },
];

function GenderFilter({ value, onChange, nonBinary }) {
  if (nonBinary) {
    const selected = value ? value.split(",") : [];

    function handleCheckbox(optValue) {
      let next;
      if (selected.includes(optValue)) {
        next = selected.filter((v) => v !== optValue);
      } else {
        next = [...selected, optValue];
      }
      onChange(next.join(",") || null);
    }

    return (
      <form className="search-input-wrap gender-filter-form">
        <div className="filter-section-heading">
          <span className="label-no-transform">Gender</span>
        </div>
        <div className="gender-radio">
          {NON_BINARY_OPTIONS.map((opt) => (
            <span key={opt.value} className="radio-option">
              <input
                type="checkbox"
                name="gender"
                value={opt.value}
                id={opt.value}
                checked={selected.includes(opt.value)}
                onChange={() => handleCheckbox(opt.value)}
              />
              <label className="gender-radio-btn" htmlFor={opt.value}>
                {opt.label}
              </label>
            </span>
          ))}
        </div>
      </form>
    );
  }

  return (
    <form className="search-input-wrap gender-filter-form">
      <div className="filter-section-heading">
        <span className="label-no-transform">Gender</span>
      </div>
      <div className="gender-radio">
        {STANDARD_OPTIONS.map((opt) => (
          <span key={opt.value} className="radio-option">
            <input
              type="radio"
              name="gender"
              value={opt.value}
              id={opt.label}
              checked={(value || "") === opt.value}
              onChange={() => onChange(opt.value || null)}
            />
            <label className="gender-radio-btn" htmlFor={opt.label}>
              {opt.label}
            </label>
          </span>
        ))}
      </div>
    </form>
  );
}

export default GenderFilter;
